import React, {useState} from "react";
import {Card, Container, Modal, Button} from "react-bootstrap";
import second from "../../components/assets/img/photo2.jpg";
import One from "../../components/assets/img/One.PNG";
import Second from "../../components/assets/img/Second.jpg";
import There from "../../components/assets/img/There.jpg";
import Four from "../../components/assets/img/Four.PNG";
import keynote3 from "../../components/assets/img/ken_up_3.jpg";
import keynote4 from "../../components/assets/img/key-4.jpg";
import sozo from "../../components/assets/img/sozo.jpg";
import mahafuz from "../../components/assets/img/4th.png";
import NoImage from "../../components/assets/img/Amit.jpg";
import './spearkers.css';
import {Link} from "react-router-dom";


const Speakers = () => {
    const [show, setShow] = useState(false);
    const [show1, setShow1] = useState(false);
    const [show2, setShow2] = useState(false);
    const [show3, setShow3] = useState(false);
    const [show4, setShow4] = useState(false);
    const [show5, setShow5] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleClose1 = () => setShow1(false);
    const handleShow1 = () => setShow1(true);
    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);
    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);
    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    return (
        <Container>
            <h2 className="pt-4 title" data-aos="fade-up">KEYNOTE / INVITED SPEAKERS</h2>
{/*<p className="d-flex justify-content-center align-items-center text-success fw-bold" >To Be Announced (TBA)</p>*/}

            <div className="row mb-2" data-aos="fade-up">
                <div className="col-md-4">
                    <Card className="shadow text-center pb-2 mb-2 align-items-center card_hight">
                        <Card.Img variant="top" src={One} className="rounded-circle"
                                  style={{height: '200px', width: '200px', marginTop: '10px'}}/>
                        <Card.Body>
                            <Card.Title> <Link to="#" onClick={handleShow}>Mohd Herwan Sulaiman </Link></Card.Title>

                        <Button className="mt-3" onClick={handleShow}>
                                Details
                        </Button>
                        </Card.Body>


                    </Card>
                </div>
                <div className="col-md-4">
                    <Card className="shadow text-center mb-2 pb-2 align-items-center card_hight">
                        <Card.Img variant="top" src={Second} className="rounded-circle"
                                  style={{height: '200px', width: '200px', marginTop: '10px'}}/>
                        <Card.Body>
                            <Card.Title> <Link to="#" onClick={handleShow1} >Latifur Khan </Link></Card.Title>
                            <Button className="mt-3" onClick={handleShow1}>
                                Details
                            </Button>
                        </Card.Body>
                    </Card>
                </div>

                <div className="col-md-4">
                    <Card className="shadow text-center mb-2 pb-2 align-items-center card_hight">
                        <Card.Img variant="top" src={There} className="rounded-circle"
                                  style={{height: '200px', width: '200px', marginTop: '10px'}}/>
                        <Card.Body>

                             <Card.Title> <Link to="#" onClick={handleShow2} >Sakib Imtiaz</Link></Card.Title>
                            <Button className="mt-3" onClick={handleShow2}>
                                Details
                            </Button>
                        </Card.Body>
                    </Card>
                </div>
                <div className="col-md-4">
                    <Card className="shadow text-center mb-2 pb-2 align-items-center card_hight">
                        <Card.Img variant="top" src={Four} className="rounded-circle"
                                  style={{height: '200px', width: '200px', marginTop: '10px'}}/>
                        <Card.Body>
                            <Card.Title> <Link to="#" onClick={handleShow3}>Jia Uddin</Link></Card.Title>
                            <Button className="mt-3" onClick={handleShow3}>
                                Details
                            </Button>
                        </Card.Body>
                    </Card>
                </div>

            </div>


            <Modal show={show} onHide={handleClose}
                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* Name Section */}

                    <p className="text-center">
                        Mohd Herwan Sulaiman <br/>
                        Associate Professor (PhD) <br/>
                        Faculty of Electrical & Electronics Engineering Technology <br/>
                        Universiti Malaysia Pahang Al-Sultan Abdullah (UMPSA),
                        26600 Pekan, Pahang, Malaysia

                    </p>

                    {/* Title Section */}
                    <h5><strong>Title:</strong></h5>
                    <p>“Advancing Energy Forecasting with Metaheuristic Enhanced Deep Learning for Power and Renewable
                        Systems”</p>

                    {/* Abstract Section */}
                    <h5><strong>Abstract:</strong></h5>
                    <p className="text-justify card_text">
                        Artificial Intelligence is increasingly transforming energy research. One of the most
                        promising developments is the integration of metaheuristic optimization algorithms with deep
                        learning models to address complex and nonlinear challenges in energy systems.
                        This keynote will explore how metaheuristics, especially those based on evolutionary
                        computation, can be combined with deep learning techniques to improve the accuracy,
                        adaptability, and reliability of energy forecasting models. The talk will highlight algorithms
                        developed by the speaker, including the Barnacles Mating Optimizer (BMO) and the
                        Evolutionary Mating Algorithm (EMA), both of which belong to the family of nature inspired
                        optimization methods. These algorithms have shown strong performance in solving high
                        dimensional and nonlinear problems in power and energy applications.
                        Several practical case studies will be presented, including forecasting energy consumption in
                        commercial buildings and estimating the state of charge in electric vehicle batteries. These
                        applications demonstrate the value of combining soft computing with deep learning in real
                        energy systems.
                        The talk will also cover intelligent forecasting approaches for managing variability in
                        renewable energy sources such as solar and wind. By embedding optimization strategies into
                        deep learning frameworks, it is possible to develop predictive tools that support stable and
                        efficient operation of modern power systems.
                        Drawing from extensive research in power system optimization and algorithm design, this
                        presentation aims to show how artificial intelligence, guided by evolutionary and swarm based
                        search strategies, can deliver scalable and intelligent solutions to meet future energy
                        challenges.
                    </p>

                    {/* Biography Section */}
                    <h5><strong>Biography:</strong></h5>
                    <p className="text-justify card_text bograpy">
                        Dr. Mohd Herwan Sulaiman received his B.Eng. (Hons) in Electrical-Electronics, M.Eng. in
                        Electrical-Power, and Ph.D. in Electrical Engineering from Universiti Teknologi Malaysia (UTM)
                        in 2002, 2007, and 2012, respectively. He is currently an Associate Professor at the Faculty of
                        Electrical & Electronics Engineering Technology, Universiti Malaysia Pahang Al-Sultan Abdullah
                        (UMPSA). His research focuses on power system optimization and the application of swarm
                        intelligence techniques in power and energy studies.

                        He has authored or co-authored over 210 technical papers in reputable international journals and
                        conferences. Dr. Herwan is the principal inventor of two nature-inspired optimization
                        algorithms: the Barnacles Mating Optimizer (BMO) and the Evolutionary Mating Algorithm (EMA),
                        both of which contribute to the field of evolutionary computation. He actively reviews for
                        several high-impact journals in power systems, soft computing, and intelligent systems.

                        In recognition of his research contributions, he serves as an Associate Editor for Franklin Open
                        (Elsevier, SCOPUS-indexed) and Energy Exploration & Exploitation (SAGE, Web of Science). He has
                        also been listed among the world’s Top 2% Scientists by Stanford University in 2022, 2023, and
                        2024. He is a Senior Member of IEEE.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={show1} onHide={handleClose1}
                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* Name Section */}

                    <p className="text-center">
                        Professor Latifur Khan <br/>
                        Fellow of IEEE, AAAS, IET, BCS <br/>
                        Department of Computer Science, University of Texas at Dallas (UT Dallas), USA

                    </p>

                    {/* Title Section */}
                    <h5><strong>Title:</strong></h5>
                    <p>Stream/Online Learning and Generative AI for Social Good, Including Cybersecurity</p>

                    {/* Abstract Section */}
                    <h5><strong>Abstract:</strong></h5>
                    <p className="text-justify card_text">
                        This presentation focuses on two key areas: stream/online machine learning and generative AI, including large language models (LLMs), as tools for addressing critical societal challenges.


                        <br/> <strong>Stream/Online Machine Learning:</strong>
                        Modern machine learning systems are increasingly deployed in dynamic environments where data evolves over time. These settings introduce challenges such as concept drift (shifts in the distribution of known classes) and concept evolution (emergence of entirely new classes). Compounding these challenges are data streams that are often unlabeled, class-imbalanced, and constrained by storage or annotation limitations—scenarios where traditional supervised learning techniques are inadequate. This talk will explore how to effectively deploy machine learning techniques in such streaming contexts, with a focus on classification and clustering in evolving data streams.

                        <br/>
                        <strong>Generative AI Applications:</strong>
                        <br/>
                        In the domain of generative AI, our research has focused on applying LLMs to support global monitoring and response efforts in high-impact areas. • Conflict and Political Violence Monitoring: In collaboration with a multidisciplinary team, we developed ConfliBERT, a domain-specific, pre-trained language model tailored to conflict and political violence data in English. ConfliBERT is openly available on GitHub and Hugging Face, with over 14,000 downloads to date. It outperforms general-purpose LLMs in classification and question-answering tasks, demonstrating the value of domain specialization in real-world applications.

                        <br/>
                        <strong>
                            Cybersecurity Intelligence Extraction:
                        </strong> <br/>
                        In partnership with researchers at NIST, we automated the extraction of cyber attack techniques from Common Vulnerabilities and Exposures (CVE) and Cyber Threat Intelligence (CTI) reports. These extracted techniques are mapped to the MITRE ATT&CK framework using a combination of LLMs and active learning strategies. We will showcase how this structured, machine-assisted analysis enhances the ability of security analysts to respond to emerging threats more effectively.
                        <strong>
                            Acknowledgments
                        </strong> <br/>
                        This work is supported by NSF, DOT, ARMY, NSA, AFOSR and NASA (in the past). The ConfliBERT project is a collaboration with Dr. Patrick Brandt and Dr. Jennifer Holmes (School of Economic, Political, and Policy Sciences, UT Dallas).

                    </p>

                    {/* Biography Section */}
                    <h5><strong>Biography:</strong></h5>
                    <p className="text-justify card_text bograpy">
                        Dr. Latifur Khan is currently a full Professor (tenured) in the Computer Science department at
                        the University of Texas at Dallas, USA where he has been teaching and conducting research since
                        September 2000. He received his Ph.D. degree in Computer Science from the University of Southern
                        California (USC) in August of 2000.
                        Dr. Khan is a fellow of IEEE, AAAS, IET, BCS, and an ACM Distinguished Scientist. He has
                        received prestigious awards including the IEEE Technical Achievement Award for Intelligence and
                        Security Informatics, IEEE Big Data Security Award, and IBM Faculty Award (research) 2016. Dr.
                        Khan has published over 300 papers in premier journals and prestigious conferences. Currently,
                        Dr. Khan’s research focuses on big data management and analytics, data mining and its
                        application to cyber security, and complex data management including geospatial data and
                        multimedia data. His research has been supported by grants from NSF, NIH, the Air Force Office
                        of Scientific Research (AFOSR), DOE, NSA, IBM, and HPE. More details can be found at
                        www.utdallas.edu/~lkhan.

                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose1}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show2} onHide={handleClose2}
                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* Name Section */}

                    <p className="text-center">
                       Sakib Imtiaz <br/>
                        Hardware Design Verification Engineer @ Microsoft, Silicon Team <br/>
                        Austin, Texas, USA

                    </p>


                    <h5><strong>Title:</strong></h5>
                    <p>Empowering ASIC Design and Verification Careers in the Semiconductor Industry</p>


                    <h5><strong>Abstract:</strong></h5>
                    <p className="text-justify card_text">
                        The growing consumer electronics and businesses demand for novel high-performance computing systems, customized artificial intelligence machine accelerators for data centers, and low-power embedded devices in the IoT has made Application-Specific Integrated Circuits (ASICs) a prolific hardware technology in the semiconductor industry. In conjunction, a labour crisis is occurring, where there is an expected shortage of more than 100,000 skilled chip engineers, mostly design verification, by 2030 in the USA alone. The emerging problem is rooted to inadequate work experience for early-in-career engineers, aging and retiring workforce, and incentives of other software driven careers. As the complexity of designs soars high, roles in design verification are becoming increasingly crucial to chip design success and market capture. The importance of design verification engineering cannot be undervalued, as the required ratio of designer to verification is trending towards 1:1, traditionally from 2:1 or even 3:1.

This talk explores key insights in pursuing a career in hardware design verification with exploration in both the academic pathway and correlation to practical experience in the workplace. There is an emphasis on the day-to-day technology stack – Hardware Descriptive Languages (HDLs) such as SystemVerilog and Verilog and key incentives on the software-hardware boundary of problem solving/co-design. Other notable Electronic Design Automation (EDA) tools include Synopsys simulator and waveform viewer. Verification methodologies also highlight the role of testbenches, assertions, coverage, Universal Verification Methodology (UVM). An overview of the full ASIC design lifecycle is conveyed for context along with key specification terms – Single Source of Truth (SSOT), memory maps and design behaviour – combinatorial and sequential digital logic, with analog (mixed-signal) design reference. This discussion is primarily intended for students and early in career engineers, to facilitate their career choice navigation in the landscape of careers in the semiconductor industry.
                    </p>


                    <h5><strong>Biography:</strong></h5>
                    <p className="text-justify card_text bograpy">
                        Mr. Sakib Imtiaz is currently a Hardware Design Verification Engineer on the Silicon Cloud Hardware Infrastructure Engineering team at Microsoft with more than 5 years with the company. He currently resides in Austin, TX however the team is scattered across the USA – California, North Carolina, Colorado, Washington, and overseas in India and Canada. He received his MASc and BASc degrees in 2014, and 2016, respectively at the University of Waterloo in Electrical & Computer Engineering. He has worked on a variety of silicon projects in his 8+ years of work experience, most notably his recent contributions to the Azure Maia AI machine accelerator system on chip (SoC) released in 2024. His day-day technologies comprise of HDL SystemVerilog, Verliog, UVM, performance modelling and EDA simulation tools and waveform debug, along with occasional Python and Perl scripting. He frequently advocates for careers in the semiconductor industry pertaining to front-and-backend roles, whether it be silicon design, verification, or physical design/synthesis. He has shared talks with numerous student groups at Texas A & M university, UT Austin, and University of Waterloo. He calls home-sweet-home as Toronto, Canada, however, shares sentimental value to being born in Bangladesh, and also raised in South Africa. Dr. Md. Nasim Akhtar is his dear uncle and his family members have inspired him from a young age to continuously learn and share knowledge.


                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose2}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
            <Modal show={show3} onHide={handleClose3}
                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Details</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {/* Name Section */}

                    <p className="text-center">
                       Jia Uddin, Ph.D <br/>
                        Associate Professor, AI and Big Data Department <br/>
                       Endicott College, Woosong University, Daejeon, South Korea

                    </p>


                    <h5><strong>Title:</strong></h5>
                    <p>Artificial Intelligence-Based Industrial Fault Diagnosis for Smart Factories</p>


                    <h5><strong>Abstract:</strong></h5>
                    <p className="text-justify card_text">
With the advent of Industry 4.0, artificial intelligence (AI)-powered smart systems are
increasingly deployed across a wide range of domains, including smart healthcare, smart
homes, smart cities, and particularly, smart factories. These systems leverage various sensors
to collect real-time data from the environment, which is then processed using AI models for
intelligent decision-making and fault diagnosis.
Traditional AI approaches have primarily relied on machine learning (ML) models, where
feature engineering plays a critical role in detection and prediction tasks. However, optimal
feature selection in ML is often challenging due to the dynamic nature of industrial
environments and data variability. To address these limitations, deep learning (DL) models
have emerged as a powerful alternative, offering the ability to automatically extract deep
features for robust fault diagnosis.

Despite their effectiveness, DL models face challenges such as high computational
complexity and limited availability of large, annotated datasets in real-world industrial
scenarios. To mitigate these issues, advanced techniques such as domain-specific transfer
learning, self-supervised learning, and few-shot learning are gaining prominence. These
methods enable the deployment of lightweight, efficient, and accurate fault diagnosis models
on edge and portable devices, making them well-suited for modern smart factory
applications.
                    </p>


                    <h5><strong>Biography:</strong></h5>
                    <p className="text-justify card_text bograpy">
                       Dr. Jia Uddin is an Associate Professor in the Artificial Intelligence and Big Data Department at Endicott College, Woosong University, South Korea. He previously served as an Associate Professor in the Computer Science and Engineering Department at BRAC University, Bangladesh. He earned his Ph.D. in Computer Engineering from the University of Ulsan, Korea (2015) and an M.Sc. in Telecommunications from Blekinge Institute of Technology, Sweden (2010).
                        <br/>
                        Dr. Jia has held faculty positions at several institutions, including the International Islamic University Chittagong, and has been invited as a visiting professor at Staffordshire University (UK), Telkom University (Indonesia), and the University of Foggia (Italy). He received the Best Research Faculty Award at BRAC University in 2016 for his research contributions.
                        <br/>
                        He has supervised numerous undergraduate and graduate theses, with several of his students receiving Best Paper Awards at international conferences. Dr. Jia has authored four books on data science and computer vision and has published over 120 SCI/Scopus-indexed journal articles, with 3,000 citations on Google Scholar. Actively involved in international research communities, he serves as a reviewer and committee member for several journals, including IEEE Access, Springer’s Multimedia Tools and Applications, Neural Computing and Applications, and others. His research interests include fault diagnosis, computer vision, and multimedia signal processing.
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose4}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={show4} onHide={handleClose4}
                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Biography</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="text-justify card_text bograpy">
                        1997 Graduated from the Department of Information Engineering, Faculty of Engineering, Kyushu
                        University. In 2002, completed the doctoral program at the Graduate School of Systems and
                        Information Sciences, Kyushu University. Since 2002, he has been an assistant at the System LSI
                        Research Center of the Institute of Systems and Information Science. Since 2006, he has been an
                        associate professor at the Research and Development Office of the University Library. Since
                        2009, he has been an associate professor at the Graduate School of Engineering, Kyushu Institute
                        of Technology. From 2018, Graduate School of Life Science and Systems Engineering, and from
                        2020, Professor at the same university. Up to now. During this time, 2009-2014 special
                        researcher at the Kyushu University Library, 2011-2012 part-time lecturer at Kyushu University
                        Graduate School of Information Science and Technology, 2014 visiting researcher at the Karlsruhe
                        Institute of Technology in Germany, 2015-2016 special researcher at the Kyushu Institute of
                        Advanced Science and Technology, 2017-2019 TeamAIBOD Co., Ltd. Technical Advisor, 2017-2019
                        Visiting Researcher, RIKEN Center for Advanced Intelligence Project. 2019 Visiting Professor,
                        University of Los Andes, Colombia. 2020 - AUTOCARE CTO LLC. 2022- Director of Care XDX Center,
                        Kyushu Institute of Technology.
                        <br/>
                        He is interested in web/ubiquitous information systems, human activity recognition using
                        smartphones, and medical applications of sensor information systems. Behavior sensor big data on
                        nursing behavior and care behavior are collected and analyzed.
                        <br/>
                        Director and senior member of Information Processing Society of Japan, member of IEEE, ACM,
                        Database Society of Japan, Institute of Electronics, Information and Communication Engineers,
                        Intelligent Information Fuzzy Society of Japan, Japan Society of Medical Informatics.
                    </p>
                    <a href="https://sozolab.jp/?fbclid=IwAR09LJfYvEwZYCrzcs_MIPSQEs09OYGXsZAaWfeErmjlwhocvFK5IsnuS84"
                       className="btn btn-primary btn-sm"
                       target="_blank" rel="noopener noreferrer">Details</a>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose4}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>


            <Modal show={show5} onHide={handleClose5}
                   size="lg"
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Biography</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p className="text-justify card_text bograpy">
                       Dr. Jia Uddin is an Associate Professor in the Artificial Intelligence and Big Data Department at Endicott College, Woosong University, South Korea. He previously served as an Associate Professor in the Computer Science and Engineering Department at BRAC University, Bangladesh. He earned his Ph.D. in Computer Engineering from the University of Ulsan, Korea (2015) and an M.Sc. in Telecommunications from Blekinge Institute of Technology, Sweden (2010).
                        <br/>
                        Dr. Jia has held faculty positions at several institutions, including the International Islamic University Chittagong, and has been invited as a visiting professor at Staffordshire University (UK), Telkom University (Indonesia), and the University of Foggia (Italy). He received the Best Research Faculty Award at BRAC University in 2016 for his research contributions.
                        <br/>
                        He has supervised numerous undergraduate and graduate theses, with several of his students receiving Best Paper Awards at international conferences. Dr. Jia has authored four books on data science and computer vision and has published over 120 SCI/Scopus-indexed journal articles, with 3,000 citations on Google Scholar. Actively involved in international research communities, he serves as a reviewer and committee member for several journals, including IEEE Access, Springer’s Multimedia Tools and Applications, Neural Computing and Applications, and others. His research interests include fault diagnosis, computer vision, and multimedia signal processing.
                    </p>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose5}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Container>
    );
};

export default Speakers;
